/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Save_FailedInputs */

const en_editor_save_failed = /** @type {(inputs: Editor_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The recipe couldn't be saved.`)
};

const de_editor_save_failed = /** @type {(inputs: Editor_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Rezept konnte nicht gespeichert werden.`)
};

/**
* | output |
* | --- |
* | "The recipe couldn't be saved." |
*
* @param {Editor_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_save_failed = /** @type {((inputs?: Editor_Save_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Save_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_save_failed(inputs)
	return en_editor_save_failed(inputs)
});